<template>
  <div>
    <a-card class="filter-card">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="标题/ID">
              <a-input v-model.trim="filterForm.keyword" placeholder="标题/ID" class="form-model-item" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="业务需求">
              <business-requirement-select v-model="filterForm.businessRequirementId" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="时间筛选" :label-col="{ span: 3 }">
              <a-input-group compact>
                <a-select v-model="filterForm.timeField" style="width: 30%" @change="onSearch">
                  <a-select-option value="createdTime"> 创建时间 </a-select-option>
                  <a-select-option value="updatedTime"> 更新时间 </a-select-option>
                </a-select>
                <a-date-picker v-model="filterForm.startDate" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="onSearch" />
                <a-date-picker v-model="filterForm.endDate" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="onSearch" />
              </a-input-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="创建人">
              <user-select v-model="filterForm.creator" allow-clear show-search show-all placeholder="创建人" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="onSearch">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card size="small">
      <a-tabs>
        <a-tab-pane key="0" :tab="`全部(${count[0] || 0})`" />
        <a-button slot="tabBarExtraContent" type="primary" icon="plus" @click="onAdd"> 新增 </a-button>
      </a-tabs>
      <document-list ref="documentListRef" @setCount="setCount" />
    </a-card>
    <document-edit ref="documentEditRef" @ok="onSearch" />
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { documentStatus } from '@/utils/dictionary';

import UserSelect from '@/components/User/UserSelect';
import DocumentEdit from '@/pages/business/document/components/DocumentEdit';
import DocumentList from '@/pages/business/document/components/DocumentList';
import BusinessRequirementSelect from '@/pages/business/document/components/BusinessRequirementSelect';

export default {
  components: { UserSelect, DocumentList, DocumentEdit, BusinessRequirementSelect },
  data() {
    return {
      filterForm: {
        keyword: null,
        category: 'MRD',
        timeField: 'createdTime',
        startDate: '',
        endDate: '',
        read: null,
        productRequirementId: null,
        businessRequirementId: null
      },
      count: {},
      documentStatus
    };
  },
  computed: {
    tabTitle() {
      return record => {
        return `${record.label} (${this.count[record.value] || 0})`;
      };
    }
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    handleChange: debounce(function () {
      this.onSearch();
    }, 500),

    onSearch() {
      this.$nextTick(() => {
        this.$refs.documentListRef.onFilter({ ...this.filterForm });
      });
    },

    onReset() {
      this.filterForm.keyword = null;
      this.filterForm.productRequirementId = null;
      this.filterForm.businessRequirementId = null;
      this.filterForm.category = 'mrd';
      this.filterForm.creator = null;
      this.filterForm.startDate = '';
      this.filterForm.endDate = '';
      this.filterForm.timeField = 'createdTime';
      this.onSearch();
    },

    onAdd() {
      this.$nextTick(() => {
        this.$refs.documentEditRef.onOpen();
      });
    },

    setCount(value) {
      this.count = value;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-tabs-tab {
  margin-right: 4px;
}

.filter-card {
  margin-bottom: 16px;
}

.search-form .ant-form-item {
  display: flex;
}

/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;
}
</style>
